import { guessTimezone } from './date';

export const TIMEZONE_COOKIE_NAME = 'user_timezone';

/**
 * Get timezone from cookie (client-side only)
 * Returns stored timezone or detects and stores new one
 */
export function getClientTimezone(): string {
  if (typeof window === 'undefined') {
    return 'UTC';
  }

  // Try to get from cookie first
  const cookies = document.cookie.split(';');
  const timezoneCookie = cookies.find((c) => c.trim().startsWith(`${TIMEZONE_COOKIE_NAME}=`));

  if (timezoneCookie) {
    const timezone = timezoneCookie.split('=')[1];
    if (timezone) {
      return timezone;
    }
  }

  // If not in cookie, detect and store
  const detected = guessTimezone();
  setClientTimezone(detected);
  return detected;
}

/**
 * Set timezone cookie (client-side only)
 */
export function setClientTimezone(timezone: string): void {
  if (typeof window === 'undefined') return;

  // Set cookie for 1 year
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);

  document.cookie = `${TIMEZONE_COOKIE_NAME}=${timezone}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}
